"use strict";
import { isInterface } from "utilities/src/platform";
export var Language = /* @__PURE__ */ ((Language2) => {
  Language2["Afrikaans"] = "af";
  Language2["Arabic"] = "ar";
  Language2["Catalan"] = "ca-ES";
  Language2["ChineseSimplified"] = "zh";
  Language2["ChineseTraditional"] = "zh-Hant";
  Language2["Czech"] = "cs";
  Language2["Danish"] = "da";
  Language2["Dutch"] = "nl";
  Language2["English"] = "en";
  Language2["Finnish"] = "fi";
  Language2["French"] = "fr";
  Language2["Greek"] = "el";
  Language2["Hebrew"] = "he";
  Language2["Hindi"] = "hi";
  Language2["Hungarian"] = "hu";
  Language2["Indonesian"] = "id";
  Language2["Italian"] = "it";
  Language2["Japanese"] = "ja";
  Language2["Korean"] = "ko";
  Language2["Malay"] = "ms";
  Language2["Norwegian"] = "no";
  Language2["Polish"] = "pl";
  Language2["Portuguese"] = "pt";
  Language2["Romanian"] = "ro";
  Language2["Russian"] = "ru";
  Language2["Serbian"] = "sr";
  Language2["SpanishSpain"] = "es";
  Language2["SpanishLatam"] = "es-419";
  Language2["SpanishUnitedStates"] = "es-US";
  Language2["Swahili"] = "sw";
  Language2["Swedish"] = "sv";
  Language2["Turkish"] = "tr";
  Language2["Ukrainian"] = "uk";
  Language2["Urdu"] = "ur";
  Language2["Vietnamese"] = "vi";
  return Language2;
})(Language || {});
export const WALLET_SUPPORTED_LANGUAGES = [
  "en" /* English */,
  "zh" /* ChineseSimplified */,
  "zh-Hant" /* ChineseTraditional */,
  "fr" /* French */,
  "ja" /* Japanese */,
  "pt" /* Portuguese */,
  "es" /* SpanishSpain */,
  "es-419" /* SpanishLatam */,
  "es-US" /* SpanishUnitedStates */,
  "vi" /* Vietnamese */
];
export const WEB_SUPPORTED_LANGUAGES = [
  "en" /* English */,
  "af" /* Afrikaans */,
  "ar" /* Arabic */,
  "ca-ES" /* Catalan */,
  "zh" /* ChineseSimplified */,
  "zh-Hant" /* ChineseTraditional */,
  "da" /* Danish */,
  "nl" /* Dutch */,
  "fi" /* Finnish */,
  "fr" /* French */,
  "el" /* Greek */,
  "he" /* Hebrew */,
  "hi" /* Hindi */,
  "hu" /* Hungarian */,
  "id" /* Indonesian */,
  "it" /* Italian */,
  "ja" /* Japanese */,
  "ko" /* Korean */,
  "ms" /* Malay */,
  "pl" /* Polish */,
  "pt" /* Portuguese */,
  "ru" /* Russian */,
  "sr" /* Serbian */,
  "es" /* SpanishSpain */,
  "es-419" /* SpanishLatam */,
  "es-US" /* SpanishUnitedStates */,
  "sw" /* Swahili */,
  "sv" /* Swedish */,
  "tr" /* Turkish */,
  "uk" /* Ukrainian */,
  "ur" /* Urdu */,
  "vi" /* Vietnamese */
];
export const PLATFORM_SUPPORTED_LANGUAGES = isInterface ? WEB_SUPPORTED_LANGUAGES : WALLET_SUPPORTED_LANGUAGES;
export const mapDeviceLanguageToLanguage = {
  "es-AR": "es-419" /* SpanishLatam */,
  "es-BO": "es-419" /* SpanishLatam */,
  "es-BZ": "es-419" /* SpanishLatam */,
  "es-BR": "es-419" /* SpanishLatam */,
  "es-CL": "es-419" /* SpanishLatam */,
  "es-CO": "es-419" /* SpanishLatam */,
  "es-CR": "es-419" /* SpanishLatam */,
  "es-CU": "es-419" /* SpanishLatam */,
  "es-DO": "es-419" /* SpanishLatam */,
  "es-EC": "es-419" /* SpanishLatam */,
  "es-SV": "es-419" /* SpanishLatam */,
  "es-GT": "es-419" /* SpanishLatam */,
  "es-GQ": "es-419" /* SpanishLatam */,
  // Equatorial Guinea is an African country but format is closer to LATAM
  "es-HN": "es-419" /* SpanishLatam */,
  "es-MX": "es-419" /* SpanishLatam */,
  "es-NI": "es-419" /* SpanishLatam */,
  "es-PA": "es-419" /* SpanishLatam */,
  "es-PY": "es-419" /* SpanishLatam */,
  "es-PE": "es-419" /* SpanishLatam */,
  "es-PR": "es-US" /* SpanishUnitedStates */,
  "es-UY": "es-419" /* SpanishLatam */,
  "es-VE": "es-419" /* SpanishLatam */
};
export var Locale = /* @__PURE__ */ ((Locale2) => {
  Locale2["Afrikaans"] = "af-ZA";
  Locale2["ArabicSaudi"] = "ar-SA";
  Locale2["Catalan"] = "ca-ES";
  Locale2["ChineseSimplified"] = "zh-Hans";
  Locale2["ChineseTraditional"] = "zh-Hant";
  Locale2["CzechCzechia"] = "cs-CZ";
  Locale2["DanishDenmark"] = "da-DK";
  Locale2["DutchNetherlands"] = "nl-NL";
  Locale2["EnglishUnitedStates"] = "en-US";
  Locale2["FinnishFinland"] = "fi-FI";
  Locale2["FrenchFrance"] = "fr-FR";
  Locale2["GreekGreece"] = "el-GR";
  Locale2["HebrewIsrael"] = "he-IL";
  Locale2["HindiIndia"] = "hi-IN";
  Locale2["HungarianHungarian"] = "hu-HU";
  Locale2["IndonesianIndonesia"] = "id-ID";
  Locale2["ItalianItaly"] = "it-IT";
  Locale2["JapaneseJapan"] = "ja-JP";
  Locale2["KoreanKorea"] = "ko-KR";
  Locale2["MalayMalaysia"] = "ms-MY";
  Locale2["NorwegianNorway"] = "no-NO";
  Locale2["PolishPoland"] = "pl-PL";
  Locale2["PortugueseBrazil"] = "pt-BR";
  Locale2["PortuguesePortugal"] = "pt-PT";
  Locale2["RomanianRomania"] = "ro-RO";
  Locale2["RussianRussia"] = "ru-RU";
  Locale2["Serbian"] = "sr-SP";
  Locale2["SpanishSpain"] = "es-ES";
  Locale2["SpanishLatam"] = "es-419";
  Locale2["SpanishUnitedStates"] = "es-US";
  Locale2["SwahiliTanzania"] = "sw-TZ";
  Locale2["SwedishSweden"] = "sv-SE";
  Locale2["TurkishTurkey"] = "tr-TR";
  Locale2["UkrainianUkraine"] = "uk-UA";
  Locale2["UrduPakistan"] = "ur-PK";
  Locale2["VietnameseVietnam"] = "vi-VN";
  return Locale2;
})(Locale || {});
export const DEFAULT_LOCALE = "en-US" /* EnglishUnitedStates */;
export const mapLanguageToLocale = {
  ["af" /* Afrikaans */]: "af-ZA" /* Afrikaans */,
  ["ar" /* Arabic */]: "ar-SA" /* ArabicSaudi */,
  ["ca-ES" /* Catalan */]: "ca-ES" /* Catalan */,
  ["zh" /* ChineseSimplified */]: "zh-Hans" /* ChineseSimplified */,
  ["zh-Hant" /* ChineseTraditional */]: "zh-Hant" /* ChineseTraditional */,
  ["cs" /* Czech */]: "cs-CZ" /* CzechCzechia */,
  ["da" /* Danish */]: "da-DK" /* DanishDenmark */,
  ["nl" /* Dutch */]: "nl-NL" /* DutchNetherlands */,
  ["en" /* English */]: "en-US" /* EnglishUnitedStates */,
  ["fi" /* Finnish */]: "fi-FI" /* FinnishFinland */,
  ["fr" /* French */]: "fr-FR" /* FrenchFrance */,
  ["el" /* Greek */]: "el-GR" /* GreekGreece */,
  ["he" /* Hebrew */]: "he-IL" /* HebrewIsrael */,
  ["hi" /* Hindi */]: "hi-IN" /* HindiIndia */,
  ["hu" /* Hungarian */]: "hu-HU" /* HungarianHungarian */,
  ["id" /* Indonesian */]: "id-ID" /* IndonesianIndonesia */,
  ["it" /* Italian */]: "it-IT" /* ItalianItaly */,
  ["ja" /* Japanese */]: "ja-JP" /* JapaneseJapan */,
  ["ko" /* Korean */]: "ko-KR" /* KoreanKorea */,
  ["ms" /* Malay */]: "ms-MY" /* MalayMalaysia */,
  ["no" /* Norwegian */]: "no-NO" /* NorwegianNorway */,
  ["pl" /* Polish */]: "pl-PL" /* PolishPoland */,
  ["pt" /* Portuguese */]: "pt-PT" /* PortuguesePortugal */,
  ["ro" /* Romanian */]: "ro-RO" /* RomanianRomania */,
  ["ru" /* Russian */]: "ru-RU" /* RussianRussia */,
  ["es" /* SpanishSpain */]: "es-ES" /* SpanishSpain */,
  ["es-419" /* SpanishLatam */]: "es-419" /* SpanishLatam */,
  ["es-US" /* SpanishUnitedStates */]: "es-US" /* SpanishUnitedStates */,
  ["sr" /* Serbian */]: "sr-SP" /* Serbian */,
  ["sw" /* Swahili */]: "sw-TZ" /* SwahiliTanzania */,
  ["sv" /* Swedish */]: "sv-SE" /* SwedishSweden */,
  ["tr" /* Turkish */]: "tr-TR" /* TurkishTurkey */,
  ["uk" /* Ukrainian */]: "uk-UA" /* UkrainianUkraine */,
  ["ur" /* Urdu */]: "ur-PK" /* UrduPakistan */,
  ["vi" /* Vietnamese */]: "vi-VN" /* VietnameseVietnam */
};
export const mapLocaleToLanguage = {
  ["af-ZA" /* Afrikaans */]: "af" /* Afrikaans */,
  ["ar-SA" /* ArabicSaudi */]: "ar" /* Arabic */,
  ["ca-ES" /* Catalan */]: "ca-ES" /* Catalan */,
  ["zh-Hans" /* ChineseSimplified */]: "zh" /* ChineseSimplified */,
  ["zh-Hant" /* ChineseTraditional */]: "zh-Hant" /* ChineseTraditional */,
  ["cs-CZ" /* CzechCzechia */]: "cs" /* Czech */,
  ["da-DK" /* DanishDenmark */]: "da" /* Danish */,
  ["nl-NL" /* DutchNetherlands */]: "nl" /* Dutch */,
  ["en-US" /* EnglishUnitedStates */]: "en" /* English */,
  ["fi-FI" /* FinnishFinland */]: "fi" /* Finnish */,
  ["fr-FR" /* FrenchFrance */]: "fr" /* French */,
  ["el-GR" /* GreekGreece */]: "el" /* Greek */,
  ["he-IL" /* HebrewIsrael */]: "he" /* Hebrew */,
  ["hi-IN" /* HindiIndia */]: "hi" /* Hindi */,
  ["hu-HU" /* HungarianHungarian */]: "hu" /* Hungarian */,
  ["id-ID" /* IndonesianIndonesia */]: "id" /* Indonesian */,
  ["it-IT" /* ItalianItaly */]: "it" /* Italian */,
  ["ja-JP" /* JapaneseJapan */]: "ja" /* Japanese */,
  ["ko-KR" /* KoreanKorea */]: "ko" /* Korean */,
  ["ms-MY" /* MalayMalaysia */]: "ms" /* Malay */,
  ["no-NO" /* NorwegianNorway */]: "no" /* Norwegian */,
  ["pl-PL" /* PolishPoland */]: "pl" /* Polish */,
  ["pt-BR" /* PortugueseBrazil */]: "pt" /* Portuguese */,
  ["pt-PT" /* PortuguesePortugal */]: "pt" /* Portuguese */,
  ["ro-RO" /* RomanianRomania */]: "ro" /* Romanian */,
  ["ru-RU" /* RussianRussia */]: "ru" /* Russian */,
  ["sr-SP" /* Serbian */]: "sr" /* Serbian */,
  ["es-ES" /* SpanishSpain */]: "es" /* SpanishSpain */,
  ["es-419" /* SpanishLatam */]: "es-419" /* SpanishLatam */,
  ["es-US" /* SpanishUnitedStates */]: "es-US" /* SpanishUnitedStates */,
  ["sw-TZ" /* SwahiliTanzania */]: "sw" /* Swahili */,
  ["sv-SE" /* SwedishSweden */]: "sv" /* Swedish */,
  ["tr-TR" /* TurkishTurkey */]: "tr" /* Turkish */,
  ["uk-UA" /* UkrainianUkraine */]: "uk" /* Ukrainian */,
  ["ur-PK" /* UrduPakistan */]: "ur" /* Urdu */,
  ["vi-VN" /* VietnameseVietnam */]: "vi" /* Vietnamese */
};
